"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SelectionToolbox = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));
var _ToolboxContainer = _interopRequireDefault(require("../Toolbox/ToolboxContainer"));
var _ToolboxRow = _interopRequireDefault(require("../Toolbox/ToolboxRow"));
var _TextTools = _interopRequireDefault(require("./TextTools"));
var _CanvasProvider = require("../../CanvasInterface/CanvasProvider");
var _Canvas = require("../../CanvasInterface/Canvas");
var _Logger = _interopRequireDefault(require("../../Utils/Logger"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _Logger["default"]('SelectionToolbox');
var SelectionToolbox = exports.SelectionToolbox = /*#__PURE__*/function (_React$Component) {
  _inherits(SelectionToolbox, _React$Component);
  var _super = _createSuper(SelectionToolbox);
  function SelectionToolbox() {
    var _this;
    _classCallCheck(this, SelectionToolbox);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      rotation: 0,
      scaling: 0
    });
    _defineProperty(_assertThisInitialized(_this), "onRotationChange", function (evt) {
      var canvas = _this.props.canvas;
      var selectedObject = canvas.selectedObject;
      if (selectedObject) {
        var rotation = evt.target.value;
        selectedObject.rotation = rotation;
        _this.setState({
          rotation: rotation
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onScalingChange", function (evt) {
      var canvas = _this.props.canvas;
      var selectedObject = canvas.selectedObject;
      if (selectedObject) {
        var scaling = +evt.target.value;
        selectedObject.scaling = scaling;
        _this.setState({
          scaling: scaling
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onMoveUpClick", function () {
      var canvas = _this.props.canvas;
      var selectedObject = canvas.selectedObject;
      if (selectedObject) {
        var idx = selectedObject.getIndex();
        selectedObject.setIndex(idx + 1);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onMoveDownClick", function () {
      var canvas = _this.props.canvas;
      var selectedObject = canvas.selectedObject;
      if (selectedObject) {
        var idx = selectedObject.getIndex();
        selectedObject.setIndex(idx - 1);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onLockChange", function (evt) {
      var canvas = _this.props.canvas;
      var selectedObject = canvas.selectedObject;
      if (selectedObject) {
        selectedObject.locked = evt.target.checked;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onAutoFitChange", function (evt) {
      var canvas = _this.props.canvas;
      var selectedObject = canvas.selectedObject;
      if (selectedObject) {
        selectedObject.autoFit = evt.target.checked;
      }
    });
    return _this;
  }
  _createClass(SelectionToolbox, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var selectedObject = this.props.selectedObject;
      if (selectedObject && selectedObject !== prevProps.selectedObject) {
        var rotation = selectedObject.rotation,
          scaling = selectedObject.scaling;
        this.setState({
          rotation: rotation,
          scaling: scaling
        });
      }
    }
  }, {
    key: "renderObjectTools",
    value: function renderObjectTools(renderObj) {
      var renderObjectTools = this.props.renderObjectTools;
      if (renderObjectTools) {
        return renderObjectTools(renderObj);
      }
      // render default
      var selectedObject = renderObj.selectedObject,
        _renderObj$state = renderObj.state,
        rotation = _renderObj$state.rotation,
        scaling = _renderObj$state.scaling,
        onRotationChange = renderObj.onRotationChange,
        onScalingChange = renderObj.onScalingChange,
        onMoveUpClick = renderObj.onMoveUpClick,
        onMoveDownClick = renderObj.onMoveDownClick,
        onLockChange = renderObj.onLockChange,
        onAutoFitChange = renderObj.onAutoFitChange;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ToolboxRow["default"], null, /*#__PURE__*/_react["default"].createElement("label", null, "Rotation: ", /*#__PURE__*/_react["default"].createElement("input", {
        type: "range",
        min: "0",
        max: "359",
        value: rotation,
        onChange: onRotationChange
      }))), /*#__PURE__*/_react["default"].createElement(_ToolboxRow["default"], null, /*#__PURE__*/_react["default"].createElement("label", null, "Scaling:", ' ', /*#__PURE__*/_react["default"].createElement("input", {
        type: "range",
        min: "0.2",
        max: "3",
        step: "0.1",
        value: scaling,
        onChange: onScalingChange
      }))), /*#__PURE__*/_react["default"].createElement(_ToolboxRow["default"], null, "Index:", /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        onClick: onMoveUpClick,
        disabled: selectedObject.isLast
      }, "Up"), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        onClick: onMoveDownClick,
        disabled: selectedObject.isFirst
      }, "Down")), /*#__PURE__*/_react["default"].createElement(_ToolboxRow["default"], null, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "lock"
      }, "Lock element", /*#__PURE__*/_react["default"].createElement("input", {
        type: "checkbox",
        id: "lock",
        name: "autoFit",
        checked: selectedObject.locked,
        onChange: onLockChange
      })), /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "autoFit"
      }, "Auto fit", /*#__PURE__*/_react["default"].createElement("input", {
        type: "checkbox",
        id: "autoFit",
        name: "autoFit",
        checked: selectedObject.autoFit,
        onChange: onAutoFitChange
      }))));
    }
  }, {
    key: "renderTextTools",
    value: function renderTextTools(renderObj) {
      var renderTextTools = this.props.renderTextTools;
      if (renderTextTools) {
        return renderTextTools(_objectSpread(_objectSpread({}, renderObj), {}, {
          components: {
            TextTools: _TextTools["default"]
          }
        }));
      }
      return /*#__PURE__*/_react["default"].createElement(_TextTools["default"], renderObj);
    }
  }, {
    key: "render",
    value: function render() {
      logger.log('render SelectionToolbox');
      var props = this.props,
        onRotationChange = this.onRotationChange,
        onScalingChange = this.onScalingChange,
        onMoveUpClick = this.onMoveUpClick,
        onMoveDownClick = this.onMoveDownClick,
        onLockChange = this.onLockChange,
        onAutoFitChange = this.onAutoFitChange,
        state = this.state;
      var children = props.children,
        selectedObject = props.selectedObject,
        canvas = props.canvas,
        classes = props.classes;
      if (selectedObject) {
        if (typeof children === 'function') {
          // call the render prop with all the necessary input
          return children({
            canvas: canvas,
            selectedObject: selectedObject,
            state: state,
            onRotationChange: onRotationChange,
            onScalingChange: onScalingChange,
            onMoveUpClick: onMoveUpClick,
            onMoveDownClick: onMoveDownClick,
            onLockChange: onLockChange,
            onAutoFitChange: onAutoFitChange,
            components: {
              ToolboxContainer: _ToolboxContainer["default"],
              ToolboxRow: _ToolboxRow["default"],
              TextTools: _TextTools["default"]
            }
          });
        }
        // render default
        return /*#__PURE__*/_react["default"].createElement(_ToolboxContainer["default"], {
          className: classes.selectionToolboxContainer
        }, this.renderObjectTools({
          canvas: canvas,
          selectedObject: selectedObject,
          state: state,
          onRotationChange: onRotationChange,
          onScalingChange: onScalingChange,
          onMoveUpClick: onMoveUpClick,
          onMoveDownClick: onMoveDownClick,
          onLockChange: onLockChange,
          onAutoFitChange: onAutoFitChange,
          components: {
            ToolboxRow: _ToolboxRow["default"]
          }
        }), selectedObject.type === 'Text' && this.renderTextTools({
          selectedObject: selectedObject,
          canvas: canvas
        }));
      }
      return null;
    }
  }]);
  return SelectionToolbox;
}(_react["default"].Component);
_defineProperty(SelectionToolbox, "propTypes", {
  children: _propTypes["default"].func,
  selectedObject: _propTypes["default"].object,
  renderObjectTools: _propTypes["default"].func,
  renderTextTools: _propTypes["default"].func,
  canvas: _propTypes["default"].instanceOf(_Canvas.AbstractCanvas).isRequired
});
var _default = exports["default"] = (0, _withStyles["default"])(_styles["default"], {
  name: 'Designer-SelectionToolbox'
})((0, _CanvasProvider.withCanvas)((0, _CanvasProvider.withCanvasState)(SelectionToolbox)));